import { Row, Typography, Button, Divider, Tag } from "antd";
import Modal from "antd/lib/modal/Modal";
import React from "react";

import { useSelector } from "react-redux";

import * as FirestoreService from "../../firebase";

const { Title, Link } = Typography;
export const Event = ({ event }) => {
  const user = useSelector((state) => state.user);
  const profile = useSelector((state) => state.profile);

  const [visible, setVisible] = React.useState(false);
  const [confirmLoading, setConfirmLoading] = React.useState(false);

  const showModal = () => {
    setVisible(true);
    console.log();
  };

  const handleOk = () => {
    setConfirmLoading(true);
    FirestoreService.eventRegister(event.id, user.username);
    setConfirmLoading(false);
    setVisible(false);
  };

  const handleCancel = () => {
    setVisible(false);
  };

  return (
    <>
      <Modal
        title={event.name}
        visible={visible}
        confirmLoading={confirmLoading}
        footer={[
          <Button key="back" onClick={handleCancel}>
            Return
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={confirmLoading}
            onClick={handleOk}
            hidden={event.participants?.includes(user.username)}
          >
            Register
          </Button>,
        ]}
      >
        <p>Event will be done via Google Meet. You can find link below:</p>
        <Link href={event.eventLink} target="_blank">
          Join Google Meet
        </Link>
      </Modal>

      <Row>
        <Row>
          <Title level={5} style={{ lineHeight: "1", marginBottom: "0px" }}>
            {event.name}
          </Title>
        </Row>
        <Row justify="space-between" align="middle" style={{ width: "100%" }}>
          {event.eventDate.toDate().toLocaleString([], {
            year: "numeric",
            month: "numeric",
            day: "numeric",
            hour: "2-digit",
            minute: "2-digit",
          })}

          {profile.odinMember ? (
            <Button
              style={{ width: "80px" }}
              type={
                event.participants?.includes(user.username)
                  ? "outline"
                  : "primary"
              }
              size="small"
              onClick={showModal}
            >
              {event.participants?.includes(user.username)
                ? "View"
                : "Register"}
            </Button>
          ) : (
            <Tag color="green" style={{ borderRadius: 5 }}>
              Members Only
            </Tag>
          )}
        </Row>
        <Divider style={{ marginTop: "10px", marginBottom: "10px" }} />
      </Row>
    </>
  );
};
